import CommonIntroductionBase from "./common/CommonIntroductionBase";

const MunicipalArchitect = () => {
  return (
    <CommonIntroductionBase
      slide="各種の建築関係の課題解決の仕組みづくり"
      collectionName="municipalarchitect"
      postTitle="建築関係情報"
      targetItems={[
        "order",
        "eventday",
        "title",
        "content",
        "linkUrl",
        "youtubeUrl",
        "image",
      ]}
      linkMode="external"
    />
  );
};

export default MunicipalArchitect;
